if (!customElements.get('video-hero')) {
  customElements.define(
    'video-hero',
    class VideoHero extends HTMLElement {
      connectedCallback() {
        this.media = this.querySelector('.video-hero__media');
        this.videoTemplate = this.querySelector('.video-hero__video-template');
        this.videoType = this.dataset.videoType;
        this.videoId = this.dataset.videoId;
        this.cutoff = this.dataset.videoCutoff || 'mobile_750';
        this.videoMuted = this.dataset.videoMuted === 'true';
        this.videoElement = null;

        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.handleMotionChange = this.handleMotionChange.bind(this);
        this.handleResize = this.debounce(this.evaluateVideo.bind(this), 250);

        this.motionQuery.addEventListener('change', this.handleMotionChange);
        window.addEventListener('resize', this.handleResize);

        this.evaluateVideo();
      }

      disconnectedCallback() {
        this.motionQuery.removeEventListener('change', this.handleMotionChange);
        window.removeEventListener('resize', this.handleResize);
        this.removeVideo();
      }

      getCutoffWidth() {
        switch (this.cutoff) {
          case 'mobile_750':
            return 750;
          case 'tablet_990':
            return 990;
          case 'all':
          default:
            return 0;
        }
      }

      shouldPlayVideo() {
        if (!this.videoType) return false;
        if (this.motionQuery.matches) return false;

        var cutoffWidth = this.getCutoffWidth();
        if (cutoffWidth > 0 && window.innerWidth < cutoffWidth) return false;

        return true;
      }

      evaluateVideo() {
        if (this.shouldPlayVideo()) {
          this.insertVideo();
        } else {
          this.removeVideo();
        }
      }

      insertVideo() {
        if (this.videoElement) return;

        if (this.videoType === 'shopify') {
          this.insertShopifyVideo();
        } else if (this.videoType === 'youtube') {
          this.insertYouTubeVideo();
        } else if (this.videoType === 'vimeo') {
          this.insertVimeoVideo();
        }
      }

      insertShopifyVideo() {
        if (!this.videoTemplate) return;

        var content = this.videoTemplate.content.cloneNode(true);
        var video = content.querySelector('video');

        if (!video) return;

        video.setAttribute('playsinline', '');
        video.muted = this.videoMuted;
        video.playsInline = true;
        video.autoplay = true;

        this.media.appendChild(video);
        this.videoElement = video;

        // For unmuted videos, we need to ensure they can autoplay
        var playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(function (error) {
            /* Autoplay blocked — poster remains visible */
            console.log('Autoplay failed:', error);
          });
        }
      }

      insertYouTubeVideo() {
        var muteParam = this.videoMuted ? '1' : '0';
        var iframe = document.createElement('iframe');
        iframe.src =
          'https://www.youtube.com/embed/' +
          this.videoId +
          '?autoplay=1&loop=1&playlist=' +
          this.videoId +
          '&controls=0&mute=' + muteParam + '&showinfo=0&rel=0&iv_load_policy=3&modestbranding=1&playsinline=1&enablejsapi=1';
        iframe.allow = 'autoplay; encrypted-media';
        iframe.setAttribute('allowfullscreen', '');
        iframe.title = 'Background video';

        this.media.appendChild(iframe);
        this.videoElement = iframe;
      }

      insertVimeoVideo() {
        var muteParam = this.videoMuted ? '1' : '0';
        var iframe = document.createElement('iframe');
        iframe.src =
          'https://player.vimeo.com/video/' +
          this.videoId +
          '?autoplay=1&loop=1&muted=' + muteParam + '&controls=0&background=1';
        iframe.allow = 'autoplay; encrypted-media';
        iframe.setAttribute('allowfullscreen', '');
        iframe.title = 'Background video';

        this.media.appendChild(iframe);
        this.videoElement = iframe;
      }

      removeVideo() {
        if (!this.videoElement) return;

        if (this.videoElement.tagName === 'VIDEO') {
          this.videoElement.pause();
          this.videoElement.removeAttribute('src');
          this.videoElement.load();
        }

        this.videoElement.remove();
        this.videoElement = null;
      }

      handleMotionChange() {
        this.evaluateVideo();
      }

      debounce(fn, delay) {
        var timer;
        return function () {
          clearTimeout(timer);
          timer = setTimeout(fn, delay);
        };
      }
    }
  );
}
